import { useSelector } from "react-redux";
import { selectSignedUserProfile, UserInfo } from "@src/app/reducers/user/userSlice";

export type AugmentedUserInfo = UserInfo & {
  isOrganizationAdmin: boolean;
  isOrganizationOwner: boolean;
}

/**
 * Returns the authenticated user profile.
 * @returns The authenticated user profile.
 */
const useAuthenticatedUser = (): AugmentedUserInfo => {
  const userInfo = useSelector(selectSignedUserProfile);
  const isOrganizationAdmin = userInfo.profile?.organization?.role === 'Admin';
  const isOrganizationOwner = userInfo.profile?.organization?.role === 'Owner';
  return { 
    ...userInfo, 
    isOrganizationAdmin,
    isOrganizationOwner,
  };
};

export default useAuthenticatedUser;